/* eslint-disable max-len */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { GoogleMap } from 'react-google-maps';
import qs from 'qs';

import MapMarker from './MapMarker.jsx';
import MapCardHOC from './MapCardHOC.jsx';
import { connect } from 'react-redux';

import { MAP } from 'react-google-maps/lib/constants';

import { getMapMarkers } from '../../../selectors';

import { fetchActions, mapActions } from '../../../actions';

class MapClass extends Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        awaitingResults: PropTypes.bool.isRequired,
        contentLoading: PropTypes.bool.isRequired,
        domain: PropTypes.string.isRequired,
        fetchSearchResults: PropTypes.func.isRequired,
        isAdmin: PropTypes.bool,
        mapState: PropTypes.object.isRequired,
        markers: PropTypes.array.isRequired,
        searchObject: PropTypes.object.isRequired,
        trackingCookieId: PropTypes.number,
        unsetMapUnstable: PropTypes.func.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        activeCard: null,
        shouldRender: false,
        zoom: 14
    }

    shouldComponentUpdate(nextProps) {
        const { awaitingResults, mapState } = nextProps;
        if (awaitingResults
            || (mapState.requiresRefit === false && this.props.mapState.requiresRefit === true)
            || (mapState.unstable === false && this.props.mapState.unstable === true)
        ) {
            return false;
        }
        return true;
    }

    componentDidUpdate() {
        if (this.props.mapState.requiresRefit) {
            this.fitMapToBounds();
        }
    }

    _unstable = false;

    fitMapToBounds = () => {
        const { markers, unsetMapUnstable } = this.props;
        const mapInstance = this._map && this._map.context[MAP];
        if (!this._unstable) {
            this._unstable = true;
            const that = this;
            google.maps.event.addListenerOnce(mapInstance, 'idle', () => {
                that._unstable = false;
                unsetMapUnstable();
            });
            if (markers && markers.length) {
                const bounds = this.getBoundsFromMarkers(markers);
                this._map.fitBounds(bounds);
            } else {
                mapInstance.setCenter(this.getCenter());
            }
        }
    }

    getBoundsFromMarkers = markers => {
        const bounds = new google.maps.LatLngBounds();
        markers.forEach((marker) => {
            const position = new google.maps.LatLng(marker.position.lat, marker.position.lng);
            bounds.extend(position);
        });
        return bounds;
    }

    getCenter = () => {
        const { markers } = this.props;
        if (markers && markers.length) {
            const bounds = this.getBoundsFromMarkers(markers);
            return this.getCenterFromBounds(bounds);
        } else {
            return this.getCenterFromSearchObject();
        }
    }

    getCenterFromBounds = bounds => {
        return bounds.getCenter();
    }

    getCenterFromSearchObject = () => {
        const { searchObject } = this.props;
        return new google.maps.LatLng({ lat: searchObject.lat, lng: searchObject.long });
    }

    getMapBounds = () => {
        return this._map.getBounds();
    }

    getMapCenter = () => {
        return this._map.getCenter();
    }

    handleMapChange = () => {
        const { handleSearch } = this;
        const {
            searchOnMapMove
        } = this.props.mapState;
        if (searchOnMapMove) {
            handleSearch();
        }
    }

    handleMapMounted = map => {
        this._map = map;
        if (this._map) {
            this.fitMapToBounds();
        }
    }

    handleMarkerClick = marker => {
        this.setState({ activeCard: marker });
    }

    handleMarkerClose = () => {
        const { activeCard } = this.state;
        if (activeCard !== null) {
            this.setState({ activeCard: null });
        }
    }

    handleSearch = () => {
        if (!this._unstable) {
            const {
                apiUrl,
                fetchSearchResults,
                trackingCookieId,
                userLang
            } = this.props;
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const params = window.location.search.split('?')[1];
            const paramsObj = qs.parse(params);
            delete paramsObj.page;
            delete paramsObj.lat;
            delete paramsObj.lon;
            paramsObj.sw_lat = this.getMapBounds().getSouthWest().lat();
            paramsObj.sw_lon = this.getMapBounds().getSouthWest().lng();
            paramsObj.ne_lat = this.getMapBounds().getNorthEast().lat();
            paramsObj.ne_lon = this.getMapBounds().getNorthEast().lng();
            fetchSearchResults(apiUrl, userLang, location, tag, qs.stringify(paramsObj), trackingCookieId);
        }
    }

    handleZoomChanged = () => {
        if (!this._unstable) {
            clearTimeout(this.functionTimer);
            this.functionTimer = setTimeout(this.handleMapChange, 500);
        }
    }

    render() {
        const {
            handleMapChange,
            handleMarkerClick,
            handleMarkerClose,
            handleZoomChanged,
            handleMapMounted,
            getCenter
        } = this;
        const {
            contentLoading,
            domain,
            markers,
            isAdmin
        } = this.props;
        const { activeCard, zoom } = this.state;
        const options = {
            clickableIcons: false,
            gestureHandling: 'greedy'
        };
        if (!isAdmin) {
            options.maxZoom = 16;
        }
        return (
            <GoogleMap
                id="googleMap"
                ref={handleMapMounted}
                defaultOptions={{
                    clickableIcons: false
                }}
                defaultZoom={14}
                onDragEnd={handleMapChange}
                defaultCenter={getCenter()}
                zoom={zoom}
                options={options}
                onZoomChanged={handleZoomChanged}
            >
                {
                    !contentLoading &&
                    // !this._unstable &&
                    <div>
                        {markers.map(marker => (
                            <MapMarker
                                key={shortid.generate()}
                                handleMarkerClick={handleMarkerClick}
                                marker={marker}
                            />
                        ))}
                        {
                            activeCard &&
                            <MapCardHOC
                                domain={domain}
                                handleMarkerClick={handleMarkerClick}
                                handleMarkerClose={handleMarkerClose}
                                marker={activeCard}
                            />
                        }
                    </div>
                }
            </GoogleMap>
        );
    }
}

const mapStateToProps = state => ({
    contentLoading: state.contentLoading,
    domain: state.config.domain,
    markers: getMapMarkers(state.searchResults),
    mapState: state.mapState,
    searchObject: state.searchObject,
    isAdmin: state.navigation.user.isAdmin,
    apiUrl: state.config.apiUrl,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang,
    awaitingResults: state.awaitingResults
});

const mapDispatchToProps = dispatch => ({
    fetchSearchResults: (apiUrl, userLang, location, tag, params, trackingCookieId) =>
        dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, params, trackingCookieId, true)),
    unsetMapUnstable: () =>
        dispatch(mapActions.unsetMapUnstable())
});

export default connect(mapStateToProps, mapDispatchToProps)(MapClass);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/MapClass.jsx